import {
  FollowPriceSuggestionForm,
  FollowPriceSuggestionSchema,
} from '@retail/price-suggestion/components';
import { useConditionActions } from '@retail/calculus/context';
import { useFormContext } from 'react-hook-form';
import { useCalculusTFunction } from '@retail/calculus/i18n';
import { useCallback } from 'react';
import { PriceSuggestionTypeWithCount } from '@retail/price-suggestion/types';
import { withDialogSuspenseErrorBoundary } from '@retail/components';
import { getConditionBindingValuesFromLevelSchema } from '@retail/calculus/components';
import { CreateConditionDialog } from '../../ConditionActionsBase';
import { CreateItemPriceSuggestionConditionForm } from './CreateItemPriceSuggestionConditionForm';

interface Props {
  open: boolean;
  supplierNumber?: number;
  priceSuggestionTypes: PriceSuggestionTypeWithCount[];
  onClose: () => void;
}

function CreatePriceSuggestionConditionDialog({
  open,
  supplierNumber,
  priceSuggestionTypes,
  onClose,
}: Props) {
  const t = useCalculusTFunction();
  const { createOrUpdateCondition } = useConditionActions();

  const {
    handleSubmit,
    formState: { errors },
    reset,
    watch,
  } = useFormContext<FollowPriceSuggestionSchema>();
  const selectedItem = watch('item');

  const submitPriceSuggestion = useCallback(
    (levelSchema: FollowPriceSuggestionSchema) => {
      createOrUpdateCondition({
        content: { priceSuggestion: { priorities: levelSchema.priceSuggestionPriority } },
        bindingValue: getConditionBindingValuesFromLevelSchema({
          levelSchema,
          supplierNumber,
        }),
        validFrom: levelSchema.fromDate,
      });

      reset();
      onClose();
    },
    [createOrUpdateCondition, onClose, reset, supplierNumber]
  );


  return (
    <CreateConditionDialog
      open={open}
      title={t('calculus.followPriceSuggestionCondition')}
      supplierNumber={supplierNumber}
      dialogContent={
        selectedItem && supplierNumber ? (
          <CreateItemPriceSuggestionConditionForm
            mgSupplierId={supplierNumber}
            mgItemNumber={selectedItem.mgItemNumber}
          />
        ) :
          <FollowPriceSuggestionForm priceSuggestionTypes={priceSuggestionTypes} />
      }
      isDisabled={Object.keys(errors).length > 0}
      onSubmit={handleSubmit(submitPriceSuggestion)}
      onClose={onClose}
    />
  );
}

export default withDialogSuspenseErrorBoundary(CreatePriceSuggestionConditionDialog);
